export const SellerData = [
  {
    image: "https://avatars.githubusercontent.com/u/110689744?v=4",
    name: "Yakshith",
    status: true,
  },
  {
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHuyEXHkec2tAFDIGicsGjqXhXJI7wnABx8A&usqp=CAU",
    name: "Trilochanprasad",
    status: true,
  },
  {
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHuyEXHkec2tAFDIGicsGjqXhXJI7wnABx8A&usqp=CAU",
    name: "Gyan Prakash",
    status: true,
  },
  {
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHuyEXHkec2tAFDIGicsGjqXhXJI7wnABx8A&usqp=CAU",
    name: "Sudhir Nandane",
    status: true,
  },
  {
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHuyEXHkec2tAFDIGicsGjqXhXJI7wnABx8A&usqp=CAU",
    name: "Priyanshu Pawar",
    status: true,
  },
];
